import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import EaListing from '@propertypal/shared/src/resources/icons/products/ea-listing-icon.svg';
import ListingMockup from '@propertypal/shared/src/resources/images/listing-a-development/dev-listing.png';
import ProductsPageHeader from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import { Box } from '@propertypal/web-ui/src/layout';
import ListingADevelopmentFeatures from '@propertypal/web-ui/src/products/ListingADevelopmentFeatures';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs from '@propertypal/web-ui/src/products/ProductScreenTabs';
import { TextLink, ListItem, Text, UnorderedList } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Listing a Development - PropertyPal',
  description: "List Your Development On Northern Ireland's Largest Property Website.",
  url: `/products/developers/listing-a-development`,
};

const PRODUCTS_URL = '/products/developers';

const ListingADevelopment = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Listing a Development"
        text="List your development on Northern Ireland's largest property website"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ mb: 10, maxWidth: 720 }}
        icon={<EaListing />}
      />
      <ProductScreenTabs
        aspectRatio="557 / 466"
        reverse
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        mockup={{
          src: ListingMockup.src,
          alt: 'Listing a Development',
        }}
        tabsMt={0}
        mockupWidth={530}
        maxW={1050}
        breakpoint={1080}
        content={
          <Box maxWidth={445}>
            <Text mb={20} lineHeight={25} align="left">
              New developments on PropertyPal provide you with an advertising channel to reach first time buyers, and
              those looking to purchase a new home. Your advertising agent will gain leads from the exposure in both the
              Residential Sales and New Homes sections of the PropertyPal website.
            </Text>
            <Text fontWeight="bold" mb={20} lineHeight={25} align="left">
              Additionally, we offer a variety of innovative advertising solutions for developers including:
            </Text>
            <UnorderedList>
              <ListItem>
                <TextLink href="/development-microsites" prefetch={false} display="flex">
                  <Box display="flex" alignItems="center" gap={5} mb={10}>
                    <span>Development Microsite</span>
                    <FontAwesomeIcon icon={faChevronRight} size={14} />
                  </Box>
                </TextLink>
              </ListItem>
              <ListItem>
                <TextLink href={`${PRODUCTS_URL}/homepage-takeover`} prefetch={false} display="flex">
                  <Box display="flex" alignItems="center" gap={5} mb={10}>
                    <span>Homepage Takeover</span>
                    <FontAwesomeIcon icon={faChevronRight} size={14} />
                  </Box>
                </TextLink>
              </ListItem>
              <ListItem>
                <TextLink href={`${PRODUCTS_URL}/sponsor-a-search`} prefetch={false} display="flex">
                  <Box display="flex" alignItems="center" gap={5} mb={10}>
                    <span>Sponsor a Search</span>
                    <FontAwesomeIcon icon={faChevronRight} size={14} />
                  </Box>
                </TextLink>
              </ListItem>
              <ListItem>
                <TextLink href={`${PRODUCTS_URL}/display-advertising`} prefetch={false} display="flex">
                  <Box display="flex" alignItems="center" gap={5} mb={10}>
                    <span>Display Advertising</span>
                    <FontAwesomeIcon icon={faChevronRight} size={14} />
                  </Box>
                </TextLink>
              </ListItem>
              <ListItem>
                <TextLink href={`${PRODUCTS_URL}/paid-social-media-advertising`} prefetch={false} display="flex">
                  <Box display="flex" alignItems="center" gap={5} mb={10}>
                    <span>Paid Social Media Advertising</span>
                    <FontAwesomeIcon icon={faChevronRight} size={14} />
                  </Box>
                </TextLink>
              </ListItem>
            </UnorderedList>
          </Box>
        }
        staticTabs
      />
      <ListingADevelopmentFeatures />
      <ProductsContact reason="Listing a Development" />
    </>
  );
};

export default ListingADevelopment;
